/***************************************
	Guidance
*****************************************/
($ => {
	if ($.guidance) {
		ui.warn('ERROR: You are including guidance.js multiple times');
		return;
	}
	const guidance = {
		create($element, options) {
			if (!options || !options.steps || options.steps.length === 0) {
				ui.warn('An array of steps must be passed in and there must at least be one step');
				return false;
			}
			let instance = $element.data('guidanceInstance');
			if (instance && $element[0] === instance.$element[0]) {
				/* if new and old triggers are the same, close/destroy the guidance */
				instance.destroy();
				return false;
			}
			$.guidance.close(); /* close/destroy any instances that may be open */
			instance = Object.create(this.proto);
			instance.config = Object.assign({}, this.staticProperties.defaults, options);
			instance.$element = $element;
			instance.active = true;
			instance.$element.data('guidanceInstance', instance);
			instance._callHandler(instance.config.onOpen);
			instance._addEvents();
			instance.goToStep(instance.config.start);
		},
		proto: {
			_addEvents() {
				$(window)
					.on('resize.guidance', ui.throttle(() => {
						if (this.active) {
							this.goToStep(this.currentStep);
						}
					}, 50))
					.on('keyup.guidance', e => {
						if (e.which === ui.keyCodes.esc) {
							this.destroy();
						}
					});
				$('html')
					.on('click.guidance', '.guidanceHighlight.spotlight', e => {
						e.stopPropagation();
						this.callout.$wrap.addClass('animateDisabled');
						this.spotlightAnimationTimeout = setTimeout(() => this.callout.$wrap.removeClass('animateDisabled'), 190); /* Disabled for 180ms (see guidance.css) */
					})
					.on('scrolledTo.guidance', (e, callback) => {
						if (this.stepSettings().position === 'top') {
							this.reposition();
						}
						this._callHandler(callback);
						this._stepOpened();
					});
				if (this.config.steps.length === 1) {
					$(document).on('click.guidance', e => {
						if ($(e.target).closest(this.$callout).length === 0 && $(e.target).closest(this.$element).length === 0) {
							this.destroy();
						}
					});
				}
			},
			_addRemoveScrollEvents(oldStepSettings, stepSettings) {
				if (oldStepSettings) {
					$(oldStepSettings.selector).closest('.calloutScrollPane').off('scroll.guidance');
				}
				$(stepSettings.selector).closest('.calloutScrollPane').on('scroll.guidance', ui.debounce(() => this.reposition(), 200));
			},
			_callHandler(handler, oldIndex, newIndex) {
				if (handler && $.isFunction(handler)) {
					handler(this.$element, oldIndex, newIndex);
				}
			},
			_createContent(stepSettings) {
				const langSets = guidance.staticProperties.langSets;
				const headingText = stepSettings.heading || '&nbsp;';
				let html = `<button aria-label="${ui.localize(langSets, 'close')}" class="guidanceCloseBtn ancBtnIconOnly icon iconClose" type="button"></button>
					<h4 class="guidanceHeader">${headingText}</h4>
					${stepSettings.content}`;
				if (this.config.steps.length > 1) {
					const prev = this.currentStep !== 0 ?
						`<button class="ancBtn silver ancBtnIconOnly guidanceControlPrevious icon iconArrowLeft" type="button">${ui.localize(langSets, 'previous')}</button>` :
						'';
					const next = this.currentStep !== this.config.steps.length - 1 ?
						`<button class="ancBtn guidanceControlNext iconAfter iconArrowRightAfter" type="button">${ui.localize(langSets, 'next')}</button>` :
						`<button class="ancBtn guidanceControlDone" type="button">${ui.localize(langSets, 'done')}</button>`;
					html += `<div class="guidanceControls clear">
						${prev}${next}
						<div class="guidanceProgress">
							${this._createProgressBullets()}
						</div>
					</div>`;
				}
				return html;
			},
			_createHighlight(highlightSetting, highlightType) {
				const $spotlight = $('.guidanceHighlight.spotlight');
				const $element = highlightSetting === true ? $(this.currentStepSettings.selector) : $(highlightSetting);
				const stepCss = {
					borderRadius: $element.css('border-radius'),
					height: $element.outerHeight(),
					left: $element.offset().left,
					top: $element.offset().top,
					width: $element.outerWidth()
				};
				const isSpotlight = highlightType === 'spotlight';
				if (isSpotlight && $spotlight.length > 0) {
					$spotlight.css(stepCss);
				} else {
					let highlightClass = highlightType;
					if (isSpotlight && this.callout.$wrap.hasClass('noTransition')) {
						highlightClass += ' noTransition';
					}
					$(`<div class="guidanceHighlight ${highlightClass}"/>`).css(stepCss).appendTo('body');
				}
			},
			_createProgressBullets() {
				if (!this.config.bullets) {
					return '';
				}
				const langSets = guidance.staticProperties.langSets;
				let html = '';
				for (let i = 0; i < this.config.steps.length; i++) {
					const currentStep = i === this.currentStep;
					const disabled = this.config.bullets === 'disabled' ? ' disabled' : '';
					const hiddenText = `${ui.localize(langSets, 'step')} ${i + 1}${currentStep ? `. ${ui.localize(langSets, 'currentStep')}.` : ''}`;
					html += `<button class="${currentStep ? 'guidanceProgressCurrent' : ''}" data-guidance-progress="${i}"${disabled} type="button">
						<span class="hideVisually">${hiddenText}</span>
					</button>`;
				}
				return html;
			},
			_createStepCallout(stepSettings) {
				if (this.callout) {
					this._destroyStepCallout();
				}
				const config = this.config;
				const $element = $(stepSettings.selector);
				const stepConfig = {
					content: this._createContent(stepSettings),
					onClose: false,
					onOpen: false,
					position: stepSettings.position,
					steps: false
				};
				const calloutConfig = Object.assign({}, config, stepConfig);
				$element.callout(calloutConfig);
				this.callout = $element.data('calloutInstance');
				this.callout.$wrap
					.css('opacity', 0)
					.addClass('animateFade')
					.on('click.guidance', '.guidanceControlPrevious', () => this.previous())
					.on('click.guidance', '.guidanceControlNext', () => this.next())
					.on('click.guidance', '.guidanceControlDone, .guidanceCloseBtn', () => this.destroy())
					.on('click.guidance', '[data-guidance-progress]', e => {
						if (config.bullets !== 'disabled') {
							this.goToStep($(e.currentTarget).data('guidance-progress'));
						}
					});
				$element.callout('open');
				if (!this.$callout) {
					this.$callout = $('#callout');
				}
			},
			destroy() {
				this._removeInteractable(this.currentStepSettings);
				this._callHandler(this.currentStepSettings.onClose);
				this._callHandler(this.config.onClose);
				clearTimeout(this.scrollAnimationTimeout);
				this.scrollAnimationTimeout = null;
				$('.guidanceForceInteraction').removeClass('guidanceForceInteraction');
				clearTimeout(this.spotlightAnimationTimeout);
				this.spotlightAnimationTimeout = null;
				this._addRemoveScrollEvents(this.currentStepSettings, {});
				this.active = false;
				$(document)
					.add('html')
					.add(window)
					.add('.calloutScrollPane')
					.off('.guidance');
				this.destroyHighlight(true);
				this._destroyStepCallout();
				this.$element
					.removeData('guidanceInstance')
					.off('.guidance')
					.focus();
			},
			destroyHighlight(removeAll) {
				return removeAll ? $('.guidanceHighlight').remove() : $('.guidanceHighlight.pulse').remove();
			},
			_destroyStepCallout() {
				if (this.callout) {
					this.callout.$wrap
						.removeClass('animateDisabled animateFade animateFadeActive')
						.off('.guidance');
					this.callout.destroy();
					this.callout = null;
				}
			},
			getCurrentStepIndex() {
				return this.currentStep;
			},
			getGuidanceCallout() {
				return this.$callout;
			},
			goToStep(stepIndex) {
				const index = ~~stepIndex; /* ensure the index is an Integer */
				const oldIndex = this.currentStep;
				const oldStepSettings = this.config.steps[oldIndex];
				if (oldStepSettings) {
					this._removeInteractable(oldStepSettings);
					this._callHandler(oldStepSettings.onClose, oldIndex, index);
				}
				this.currentStep = index;
				const stepSettings = Object.assign({}, guidance.staticProperties.stepDefaults, { selector: this.$element }, this.config.steps[index]);
				this.currentStepSettings = stepSettings;
				this._addRemoveScrollEvents(oldStepSettings, stepSettings);
				this.destroyHighlight();
				this._callHandler(stepSettings.onOpen, oldIndex, index);
				this._updateElementAttributes();
				const delay = index < oldIndex && stepSettings.backDelay !== false ? stepSettings.backDelay : stepSettings.delay;
				this.scrollAnimationTimeout = setTimeout(() => {
					this._createStepCallout(stepSettings);
					this._highlightTarget();
					this._scrollToGuidance(stepSettings, () => {
						this._updateElementAttributes(true);
						this._callHandler(stepSettings.onAfterOpen, oldIndex, index);
					});
					this.$element.trigger('contentCreated.guidance');
				}, delay);
			},
			_highlightTarget() {
				this.destroyHighlight(); /* spotlight is re-used, but pulse is not - always destroy pulse */
				const currentStep = this.currentStepSettings;
				if (currentStep.pulse && currentStep.pulse !== currentStep.spotlight) {
					this._createHighlight(currentStep.pulse, 'pulse');
				}
				if (currentStep.spotlight) {
					this._createHighlight(currentStep.spotlight, 'spotlight');
				}
			},
			next() {
				const nextStep = this.currentStep + 1;
				return nextStep < this.config.steps.length ? this.goToStep(nextStep) : ui.warn('There is no next step');
			},
			previous() {
				const previousStep = this.currentStep - 1;
				return previousStep !== -1 ? this.goToStep(previousStep) : ui.warn('There is no previous step');
			},
			_removeInteractable(stepSettings) {
				if (stepSettings && stepSettings.makeInteractable) {
					const selector = typeof stepSettings.spotlight === 'boolean' ? stepSettings.selector : stepSettings.spotlight;
					$(selector).removeClass('guidanceForceInteraction');
				}
			},
			reposition() {
				this.callout.position();
				this._highlightTarget();
				$(this.currentStepSettings.selector).removeClass('hover active');
			},
			_scrollToGuidance(stepSettings, callback) {
				if (stepSettings.scroll !== false) {
					let topOffset = stepSettings.topOffset;
					if (stepSettings.position === 'top' && this.$callout.hasClass('calloutPositionBottom')) {
						topOffset -= this.callout.$wrap.outerHeight();
					}
					const animateDuration = this.callout.$wrap.hasClass('noTransition') ? 0 : 800; /* 800ms looks good */
					$('html, body').animate({
						scrollTop: this.callout.$wrap.offset().top + topOffset
					}, animateDuration, ui.throttle(() => {
						this.$element.trigger('scrolledTo.guidance', callback);
					}, 100, true));
				} else {
					this._callHandler(callback);
					this._stepOpened();
				}
			},
			_stepOpened() {
				this.$element.trigger('stepOpened.guidance');
			},
			stepSettings() {
				return this.currentStepSettings;
			},
			_updateElementAttributes(isStepRendering) {
				if (this.callout) {
					if (isStepRendering) {
						this.callout.$wrap
							.addClass('animateFadeActive')
							.attr('role', 'alertdialog').focus();
					} else {
						this.callout.$wrap
							.removeClass('animateFadeActive')
							.removeAttr('role');
					}
				}
				const spotlight = this.currentStepSettings.spotlight;
				if (this.currentStepSettings.makeInteractable && spotlight) {
					const selector = typeof spotlight === 'boolean' ? this.currentStepSettings.selector : spotlight;
					$(selector).addClass('guidanceForceInteraction');
				}
			}
		},
		staticProperties: {
			defaults: {
				bullets: true, /* Accepts true (default), false, 'disabled' - Shows bullets, hides bullets, shows bullets but not clickable (respectively) */
				classes: '', /* Class(es) to add to .calloutContent (separate with space, no dot) */
				hidePointer: false, /* Set to true to hide pointer */
				onClose: false,
				onOpen: false,
				start: 0, /* Integer - Starting step based on the steps array provided - matches 0 based index of array */
				steps: [], /* Array of objects representing different steps and settings per step */
				style: 'guidance', /* Style passed to callout that creates custom behavior and settings for guidance - NOT DOCUMENTED - SHOULD NOT CHANGE */
				type: 'guidance' /* 'guidance' for callout - NOT DOCUMENTED - SHOULD NOT CHANGE */
			},
			stepDefaults: {
				backDelay: false, /* accepts false (default) | integer - Delay added before step will create, scroll, highlight and show - only if going to previous step - falls back to delay */
				content: '', /* Accepts string / text or HTML */
				delay: 100, /* Accepts integer - Delay added before step will create, scroll, highlight and show */
				heading: '', /* Accepts String */
				makeInteractable: false, /* Accepts false (default) | true - changes the z-index of the element so it can be clicked and scrolled */
				onAfterOpen: false, /* function ($trigger, oldStepIndex, newStepIndex) { } Callback to run After Guidance has been created, scrolled to, highighted, and is being faded in */
				onClose: false, /* function ($trigger, oldStepIndex, newStepIndex) { } Callback to run *before* step closes and moves to next */
				onOpen: false, /* function ($trigger) { } Callback to run *before* guidance is created, scrolled to, highlighted */
				position: 'bottom', /* Position of callout relative to trigger: 'bottom' (default) | 'left' | 'right' */
				pulse: false, /* Accepts false (default) | true | String Selector */
				scroll: true, /* Accepts true (default) | false */
				selector: '', /* Accepts jQuery String Selector | Defaults to $trigger */
				spotlight: true, /* Accepts true (default) | false | String Selector */
				topOffset: -100 /* Accepts integer - Negative scroll added to the top of the element or guidance callout so relative items above the guidance callout are shown. */
			},
			langSets: {
				de: {
					close: 'Schließen',
					currentStep: 'Aktueller Schritt',
					done: 'Fertig',
					next: 'Weiter',
					previous: 'Zurück',
					step: 'Schritt'
				},
				en: {
					close: 'Close',
					currentStep: 'Current Step',
					done: 'Done',
					next: 'Next',
					previous: 'Previous',
					step: 'Step'
				},
				es: {
					close: 'Cerrar',
					currentStep: 'Paso actual',
					done: 'Listo',
					next: 'Siguiente',
					previous: 'Anterior',
					step: 'Paso'
				},
				fr: {
					close: 'Fermer',
					currentStep: 'Étape actuelle',
					done: 'Terminé',
					next: 'Suivant',
					previous: 'Précédent',
					step: 'Étape'
				},
				it: {
					close: 'Chiudi',
					currentStep: 'Passaggio corrente',
					done: 'Fine',
					next: 'Avanti',
					previous: 'Indietro',
					step: 'Passaggio'
				},
				sv: {
					close: 'Stäng',
					currentStep: 'Aktuellt steg',
					done: 'Klart',
					next: 'Nästa',
					previous: 'Föregående',
					step: 'Steg'
				}
			}
		}
	};
	/* Plugin definition */
	$.fn.guidance = function init(options, ...args) {
		const isMethodCall = typeof options === 'string';
		let returnValue = this;
		if (isMethodCall) {
			const instance = this.data('guidanceInstance');
			if (!instance) {
				ui.warn(`Cannot call methods on guidance prior to initialization; attempted to call method "${options}".`);
				return false;
			}
			if (!$.isFunction(instance[options]) || options.indexOf('_') === 0) {
				ui.warn(`No such method ${options} for guidance.`);
				return false;
			}
			const methodValue = instance[options](...args);
			if (methodValue !== instance && methodValue !== undefined) {
				returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
			}
		} else {
			guidance.create(this, options);
		}
		return returnValue;
	};
	/* Expose testable methods */
	$.guidance = {
		close() {
			$('.callout.guidance.open .guidanceCloseBtn').click();
		},
		getTest() {
			return Object.assign({}, guidance);
		}
	};
})(jQuery);
